import {startCase, replace, capitalize} from "lodash";

export const deKebabCase = (text, capitaliseAll) => {
    return capitaliseAll ? startCase(text) : capitalize(replace(text, "-", " "));
}